export default [
  { action: `manage`, subject: `domain` },
  { action: `manage`, subject: `workorder` },
  { action: `manage`, subject: `bait` },
  { action: `manage`, subject: `prompt` },
];
